import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function timelineReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(
            ACTION_NAMES.CONTACT_TIMELINE,
            CRUD_ACTION_TYPES.READ_ONE_REQUEST
        ):
            return {
                ...state,
                isReadingTimeline: true,
                timeline: [],
                count: 0,
            };
        case getNamedAction(
            ACTION_NAMES.CONTACT_TIMELINE,
            CRUD_ACTION_TYPES.READ_ONE_SUCCESS
        ):
            return {
                ...state,
                isReadingTimeline: false,
                timeline: action.data.data || [],
                count: action.data.count,
                token: action.data.token,
            };
        case getNamedAction(
            ACTION_NAMES.CONTACT_TIMELINE,
            CRUD_ACTION_TYPES.READ_ONE_FAILURE
        ):
            return { ...state, isReadingTimeline: false };

        case getNamedAction(
            ACTION_NAMES.ACCOUNT_TIMELINE_CONTACT,
            CRUD_ACTION_TYPES.READ_ONE_REQUEST
        ):
            return {
                ...state,
                isReadingAccountTimelineContacts: true,
                accountTimelineContacts: [],
            };

        case getNamedAction(
            ACTION_NAMES.ACCOUNT_TIMELINE_CONTACT,
            CRUD_ACTION_TYPES.READ_ONE_SUCCESS
        ):
            return {
                ...state,
                isReadingAccountTimelineContacts: false,
                accountTimelineContacts: action?.data || [],
            };

        case getNamedAction(
            ACTION_NAMES.ACCOUNT_TIMELINE_CONTACT,
            CRUD_ACTION_TYPES.READ_ONE_FAILURE
        ):
            return { ...state, isReadingAccountTimelineContacts: false };
        default:
            return state;
    }
}

export default timelineReducer;
